/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { api } from "api";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import Select from "react-select";
import i18n from "i18next";
import Helpers from "util/helpers";
import TrainingScore from "./TrainingScore";

/*
      MechanicalS = 10049;
      Body / PaintS = 10050
      SalesS = 10047
      Service Administration = 10048
    */

class TrainingScores extends Component {
  state = {
    trainings: [],
    filteredTrainingsData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    dataFetched: false,
    sort_by: "trName", // training name by default
    sort_dir: "desc",
    isManager: localStorage.getItem("roles").includes("Manager"),
    selectedDepartment: null,
    selectedEmployee: null,
    employeeOptions: [],
    employees: [],
  };

  settings = {
    itemsPerPage: 10,
  };

  deparmentOptions = [
    { value: "50020", label: i18n.t("10049") },
    { value: "50021", label: i18n.t("10050") },
    { value: "50022", label: i18n.t("10047") },
    { value: "50023", label: i18n.t("10048") },
  ];

  componentDidMount() {
    if (localStorage.getItem("roles").includes("Manager")) this.getEmployees();

    if (!localStorage.getItem("roles").includes("Manager"))
      this.getTrainingScores();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.employees !== this.state.employees) {
      const currentEmployee = this.state.employees.find(
        (z) => z.id === this.props.profile.general.id
      );

      if (!currentEmployee) return;

      const currentEmployeeDepartment = this.deparmentOptions.find(
        (o) => o.value === String(currentEmployee.serviceType.value)
      );

      const employeesOfDepartment = this.state.employees.filter(
        (z) => z.serviceType.value === currentEmployee.serviceType.value
      );
      const _employeeOptions = employeesOfDepartment.map((e) => ({
        value: e.id,
        label: e.fullname,
      }));

      this.setState({
        selectedDepartment: currentEmployeeDepartment.value,
        selectedEmployee: currentEmployee.id,
        employeeOptions: _employeeOptions,
      });

      this.getTrainingScores(currentEmployee.id);
    }

    if (prevState.selectedDepartment !== this.state.selectedDepartment) {
      const employeesOfDepartment = this.state.employees.filter(
        (z) => z.serviceType.value === parseInt(this.state.selectedDepartment)
      );
      const _employeeOptions = employeesOfDepartment.map((e) => ({
        value: e.id,
        label: e.fullname,
      }));
      this.setState({
        employeeOptions: _employeeOptions,
      });
    }

    if (prevState.selectedEmployee !== this.state.selectedEmployee) {
      this.getTrainingScores(this.state.selectedEmployee);
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredTrainingsData: this.state.trainings.filter((item) => {
          return Helpers.getTurkishCharaterFixedList(
            item.training.name
          ).includes(
            Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
          );
        }),
      });
    }
  }

  getEmployees = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/employee-360/employees`)
      .then((response) => {
        this.setState({
          employees: response.data.data.employees,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  getTrainingScores = (employeeId) => {
    if (!employeeId) return;
    this.props.onProcessBegin();
    let query = "";
    if (this.state.isManager)
      query = `/api/employee-360/training-scores/${employeeId}`;
    else query = "/api/employee-360/training-scores";
    api
      .get(query)
      .then((response) => {
        this.setState({
          trainings: response.data.data.trainings,
          filteredTrainingsData: response.data.data.trainings,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  handleDepartmentSelect = (e) => {
    this.setState({ selectedDepartment: e.value, selectedEmployee: null });
  };

  renderDepartmentCombo = () => {
    return (
      <Select
        placeholder={i18n.t("10521")}
        options={this.deparmentOptions}
        onChange={(e) => this.handleDepartmentSelect(e)}
        // defaultValue={options[0]}
        value={this.deparmentOptions.find(
          (o) => o.value === String(this.state.selectedDepartment)
        )}
      />
    );
  };

  handleEmployeeSelect = (e) => {
    this.setState({ selectedEmployee: e.value });
  };

  renderEmployeesCombo = () => {
    return (
      <Select
        placeholder={i18n.t("10521")}
        label="ee"
        options={this.state.employeeOptions}
        onChange={(e) => this.handleEmployeeSelect(e)}
        value={
          this.state.selectedEmployee
            ? this.state.employeeOptions.find(
              (o) => o.value === this.state.selectedEmployee
            )
            : null
        }
      />
    );
  };

  renderPosition = () => {
    if (
      this.state.selectedEmployee === null ||
      this.state.selectedEmployee === ""
    )
      return null;
    const employee = this.state.employees.find(
      (z) => z.id === this.state.selectedEmployee
    );
    return <span>{employee.position.name}</span>;
  };

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18n.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderPager = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18n.t(10110)}
          nextPageText={i18n.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredTrainingsData?.length > 0
              ? this.state.filteredTrainingsData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  trType = "";
  trName = "";
  trScore = "";
  trStartDate = "";
  trEndDate = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trType = "";
    this.trName = "";
    this.trScore = "";
    this.trStartDate = "";
    this.trEndDate = "";
    switch (this.state.sort_by) {
      case "trType":
        this.trType = `_${this.state.sort_dir}`;
        break;
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "trScore":
        this.trScore = `_${this.state.sort_dir}`;
        break;
      case "trStartDate":
        this.trStartDate = `_${this.state.sort_dir}`;
        break;
      case "trEndDate":
        this.trEndDate = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredTrainingsData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
        case "trScore":
          return this.state.sort_dir === "desc"
            ? a.score - b.score
            : b.score - a.score;
        case "trStartDate":
          return this.state.sort_dir === "desc"
            ? new Date(a.startDate) - new Date(b.startDate)
            : new Date(b.startDate) - new Date(a.startDate);
        case "trEndDate":
          return this.state.sort_dir === "desc"
            ? new Date(a.endDate) - new Date(b.endDate)
            : new Date(b.endDate) - new Date(a.endDate);
        case "trType":
          return this.state.sort_dir === "desc"
            ? a.method.label.localeCompare(b.method.label)
            : b.method.label.localeCompare(a.method.label);
        default:
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
      }
    });

    return sorted.slice(start, end).map((t) => {
      return <TrainingScore key={t.key} t={t} />;
    });
  };

  renderFilterBar = () => {
    if (!this.state.isManager) return null;

    return (
      <div className="mb-4">
        <div className="d-flex flex-column flex-lg-row justify-content-end align-items-center mb-4">
          <div
            className="d-flex align-items-center flex-grow-1 w-100"
            style={{ gap: "10px" }}
          >
            <label>
              <Trans>employee360_department</Trans>
            </label>
            <div style={{ width: "100%", maxWidth: "300px" }}>
              {this.renderDepartmentCombo()}
            </div>
          </div>
          <div
            className="d-flex align-items-center flex-grow-1 w-100"
            style={{ gap: "10px" }}
          >
            <label>
              <Trans>employee360_personnel</Trans>
            </label>
            <div style={{ width: "100%", maxWidth: "300px" }}>
              {this.renderEmployeesCombo()}
            </div>
          </div>
          <div
            className="d-flex align-items-center flex-grow-1 w-100"
            style={{ gap: "10px" }}
          >
            <label>
              <Trans>employee360_position</Trans>
            </label>
            {this.renderPosition()}
          </div>
        </div>
        <hr />
      </div>
    );
  };

  handleExport = (employeeId) => {
    this.props.onProcessBegin();
    api
      .get(`/api/employee-360/export-training-scores/${employeeId}`)
      .then((response) => {
        const fileName = response.headers["content-disposition"]
          .split(";")[1]
          .split("=")[1];
        this.downloadFile(response, fileName);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  downloadFile = (res, fname) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fname);
    document.body.appendChild(link);
    link.click();
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        {this.state.selectedEmployee && (
          <button
            className="export-button"
            onClick={() => this.handleExport(this.state.selectedEmployee)}
          >
            <Trans desc="Dışa Aktar">10113</Trans>
          </button>
        )}
      </div>
    );
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();
    return (
      <>
        {this.renderFilterBar()}

        <div className="d-flex justify-content-left mb-4">
          <b>
            <Trans>employee360_successstatus</Trans>
          </b>
          <div
            style={{
              background: "#4cc790",
              borderRadius: "20px",
              textAlign: "center",
              padding: "0px 16px",
              color: "#fff",
              marginLeft: "10px",
            }}
          >
            <Trans>employee360_successful</Trans>
          </div>
          <div
            style={{
              background: "#e42c3b",
              borderRadius: "20px",
              textAlign: "center",
              padding: "0px 16px",
              color: "#fff",
              marginLeft: "10px",
            }}
          >
            <Trans>employee360_notyet</Trans>
          </div>
        </div>

        <div>{this.renderPager()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="kayitliEgitimler"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive tgE dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trType")}
                  className={`all sorting${this.trType}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Tür">10114</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trName")}
                  className={`all sorting${this.trName}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Eğitim Adı">10115</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trStartDate")}
                    className={`desktop sorting${this.trStartDate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10117</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trEndDate")}
                    className={`desktop sorting${this.trEndDate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10118</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trScore")}
                    className={`desktop sorting${this.trScore}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Puan">10177</Trans>
                    </div>
                  </th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        {/* {this.renderFooterToolbar()} */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    profile: state.profile,
  };
};

export default connect(
  mapStateToProps,
  {}
)(requireAuth(containsLongRunningProcess(TrainingScores)));
